import { useRef, useEffect } from "react";
import type { DisplayMessage } from "../../types"; // Adjust path if needed
import { MessageContent } from "./message-content";

// --- Component ---

interface MessageListProps {
  messages: DisplayMessage[];
}

export function MessageList({ messages }: MessageListProps) {
  const messagesEndRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <div className="mb-4 flex flex-grow flex-col overflow-y-auto rounded-lg bg-slate-100 p-3">
      <div className="mt-auto" /> {/* Spacer */}
      {messages.map((msg) => {

        return (
          <div
            key={msg.id}
            className={`message mb-2 flex-shrink-0 rounded-md p-2.5 shadow-sm ${
              msg.isStatus ? "bg-slate-200 text-slate-600" : "bg-white"
            } ${
              msg.type === "ad"
                ? "bg-yellow-100 text-yellow-800"
                : msg.type === "error"
                ? "bg-red-100 text-red-800"
                : ""
            }`}
          >
            {/* Timestamp */}
            <span className="timestamp mr-2 text-xs text-slate-500 text-nowrap">
              {msg.timestamp instanceof Date && !isNaN(msg.timestamp.getTime())
                ? msg.timestamp.toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })
                : "Invalid time"}
            </span>

            {/* Content */}
            <MessageContent text={msg.content} />
          </div>
        );
      })}
      <div ref={messagesEndRef} /> {/* Scroll target */}
    </div>
  );
}
